import { Tooltip } from 'components-antd';
import { CommentPopover } from '../CommentPopover';
import styles from './styles.module.scss';
import { useEffect, useRef, useState } from 'react';

export const CommentTooltip = (props) => {
  const { children, field, isHighlighted, manageOffset, scale, width } = props;

  const [open, setOpen] = useState(isHighlighted);
  const ref = useRef<any>();

  useEffect(() => {
    setOpen(isHighlighted);
  }, [isHighlighted]);

  const { x, y, height } = field.meta.coordinates;

  return (
    <div
      className={styles.tooltipWrapper}
      onClick={(e) => {
        !open && setOpen(true);
      }}
      style={
        manageOffset
          ? {
              left: x * scale,
              top: y * scale,
              width: width * scale,
              height: height * scale,
              position: 'absolute',
            }
          : undefined
      }
      ref={ref}
    >
      <Tooltip
        placement="top"
        key={`${field.id}-pdfField-tooltip`}
        title={<CommentPopover {...props} hideTooltip={() => setOpen(false)} itemRef={ref} />}
        open={open}
        overlayClassName={styles.toolTipContainer}
        destroyTooltipOnHide
        trigger={'click'}
        getPopupContainer={() => ref.current}
        onOpenChange={(visible) => setOpen(visible)}
      >
        {children}
      </Tooltip>
    </div>
  );
};
